import { render } from "./ClientFirstStep.vue?vue&type=template&id=528a95ec&scoped=true"
import script from "./ClientFirstStep.vue?vue&type=script&lang=js"
export * from "./ClientFirstStep.vue?vue&type=script&lang=js"

import "./ClientFirstStep.vue?vue&type=style&index=0&id=528a95ec&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528a95ec"]])

export default __exports__